import React, { ForwardedRef, useImperativeHandle, useRef } from 'react';
import { PieChartProps, ChartRef } from '../_config/_interface';
import PieChart from './PieChart';

const AnalysisPieChartInner: React.ForwardRefRenderFunction<ChartRef, PieChartProps> = (props, ref: ForwardedRef<ChartRef>) => {
  const { condition,pieChartTitle } = props;
  const chartRef = useRef<ChartRef>(null);
  // 获取实例
  const instance = () => chartRef?.current?.instance();
  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance
  }));

  const showLegends = condition?.group_by?.length > 0 &&
        (!(condition?.group_by?.length === 1 && condition?.group_by?.[0]?.column_type === "date")); // 是否显示图例和延长线label; 没有分类维度并且分类维度只有日期的时候不显示

  return <PieChart ref={chartRef} showLegends={showLegends} pieChartTitle={pieChartTitle}  {...props} />;
};

const AnalysisPieChart = React.forwardRef(AnalysisPieChartInner);

export default AnalysisPieChart;